import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal modal--user",
  id: "modal-broker-edit"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "confirm-delete"
}
const _hoisted_4 = { class: "confirm-delete-content" }
const _hoisted_5 = { class: "confirm-delete-alert" }
const _hoisted_6 = { class: "confirm-delete-item" }
const _hoisted_7 = {
  key: 0,
  class: "confirm-delete-info"
}
const _hoisted_8 = { class: "buttons buttons-inline" }
const _hoisted_9 = {
  key: 1,
  class: "confirm-delete"
}
const _hoisted_10 = { class: "confirm-delete-content" }
const _hoisted_11 = { class: "confirm-delete-alert" }
const _hoisted_12 = { class: "confirm-delete-item" }
const _hoisted_13 = {
  key: 0,
  class: "confirm-delete-info"
}
const _hoisted_14 = { class: "buttons buttons-inline" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "modal-header" }
const _hoisted_19 = { class: "modal-title" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_22 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_23 = { class: "form-section has-aside" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "frm-estateAgentEditForm_firstName" }
const _hoisted_26 = {
  key: 0,
  class: "form-error"
}
const _hoisted_27 = { for: "frm-estateAgentEditForm_lastName" }
const _hoisted_28 = {
  key: 0,
  class: "form-error"
}
const _hoisted_29 = { for: "frm-estateAgentEditForm_email" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "form-error"
}
const _hoisted_32 = {
  key: 1,
  class: "form-error"
}
const _hoisted_33 = { for: "frm-estateAgentEditForm_confirmEmail" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "help" }
const _hoisted_36 = {
  key: 0,
  class: "form-error"
}
const _hoisted_37 = {
  key: 1,
  class: "form-error"
}
const _hoisted_38 = { for: "frm-estateAgentEditForm_phoneNumber" }
const _hoisted_39 = { class: "multiple-inputs" }
const _hoisted_40 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_41 = {
  key: 0,
  class: "form-error"
}
const _hoisted_42 = {
  key: 0,
  class: "form-error"
}
const _hoisted_43 = {
  key: 1,
  class: "form-error"
}
const _hoisted_44 = { class: "form-field" }
const _hoisted_45 = { for: "frm-estateAgentEditForm_role" }
const _hoisted_46 = { class: "selectbox" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["value"]
const _hoisted_49 = { for: "frm-estateAgentProfileForm_motto" }
const _hoisted_50 = {
  key: 0,
  class: "form-error"
}
const _hoisted_51 = { for: "frm-estateAgentProfileForm_description" }
const _hoisted_52 = {
  key: 0,
  class: "form-error"
}
const _hoisted_53 = { class: "form-field full-width" }
const _hoisted_54 = { for: "frm-estateAgentProfileForm_languages" }
const _hoisted_55 = { class: "checkbox checkbox--lang" }
const _hoisted_56 = ["value"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_58 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_59 = { class: "form-upload-photo aspect-ratio aspect-ratio-1-1" }
const _hoisted_60 = { class: "aspect-ratio-body" }
const _hoisted_61 = {
  key: 0,
  class: "photo is-uploaded"
}
const _hoisted_62 = {
  key: 1,
  class: "upload-placeholder placeholder-user"
}
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = {
  key: 0,
  class: "form-error"
}
const _hoisted_65 = { class: "form-footer" }
const _hoisted_66 = { class: "buttons-inline" }
const _hoisted_67 = { class: "button button--primary" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.showConfirmDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-delete')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.model.firstName) + " " + _toDisplayString(_ctx.model.lastName), 1),
                  (_ctx.model.adCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-info', { count: _ctx.model.adCount, fullName: _ctx.user.fullName })), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "button delete",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteAgent && _ctx.deleteAgent(...args)))
                    }, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-button-delete')), 1),
                    _createElementVNode("button", {
                      class: "button cancel",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmDelete = false))
                    }, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-button-cancel')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showConfirmArchive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-archive')), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.model.firstName) + " " + _toDisplayString(_ctx.model.lastName), 1),
                  (_ctx.model.adCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-archive-info', { count: _ctx.model.adCount, fullName: _ctx.user.fullName })), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "button delete",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteAgent && _ctx.deleteAgent(...args)))
                    }, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-button-archive')), 1),
                    _createElementVNode("button", {
                      class: "button cancel",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showConfirmArchive = false))
                    }, _toDisplayString(_ctx.$t('EstateAgentEdit.confirm-button-archive-cancel')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "modal-close",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_16),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('EstateAgentEdit.title')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('EstateAgentEdit.subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("form", {
                id: "estateAgent-form",
                class: "form",
                onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                (_ctx.isError || _ctx.errors.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_ctx.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.firstName.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('EstateAgentEdit.firstName')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.form.firstName.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentEditForm_firstName",
                        name: "firstName",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.firstName.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.firstName.$dirty && _ctx.v$.form.firstName.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.firstName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.lastName.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('EstateAgentEdit.lastName')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.lastName.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentEditForm_lastName",
                        name: "lastName",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.lastName.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.lastName.$dirty && _ctx.v$.form.lastName.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.lastName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('EstateAgentEdit.email')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                        type: "text",
                        disabled: !_ctx.isEmailEnabled,
                        id: "frm-estateAgentEditForm_email",
                        name: "email",
                        class: "form-control is-required"
                      }, null, 8, _hoisted_30), [
                        [
                          _vModelText,
                          _ctx.v$.form.email.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.email.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.email.email.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('forms.email')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmEmail.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('EstateAgentEdit.email')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.form.confirmEmail.$model) = $event)),
                        onPaste: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                        type: "text",
                        disabled: !_ctx.isEmailEnabled,
                        id: "frm-estateAgentEditForm_confirmEmail",
                        name: "confirmEmail",
                        class: "form-control is-required"
                      }, null, 40, _hoisted_34), [
                        [
                          _vModelText,
                          _ctx.v$.form.confirmEmail.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('EstateAgentEdit.email-help-confirm')), 1),
                      (_ctx.v$.form.confirmEmail.$dirty && _ctx.v$.form.confirmEmail.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.confirmEmail.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.confirmEmail.sameAsEmail.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('EstateAgentEdit.email-mismatch')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('EstateAgentEdit.phoneNumber')) + ":", 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_PhonePrefix, {
                            id: "frm-estateAgentEditForm_phoneNumberPrefix",
                            modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                          type: "text",
                          id: "frm-estateAgentEditForm_phoneNumber",
                          placeholder: "900 000 000",
                          name: "phoneNumber",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.phoneNumber.$model,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      (_ctx.v$.form.phoneNumberPrefix.$dirty && _ctx.v$.form.phoneNumberPrefix.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.phoneNumberPrefix.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      ((_ctx.v$.form.phoneNumberPrefix.$dirty || _ctx.v$.form.phoneNumber.$dirty) && _ctx.v$.form.phoneNumber.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.v$.form.phoneNumber.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('EstateAgentEdit.role')) + ":", 1),
                      _createElementVNode("div", _hoisted_46, [
                        _withDirectives(_createElementVNode("select", {
                          id: "frm-estateAgentEditForm_role",
                          name: "role",
                          disabled: _ctx.user.frontUserId === _ctx.model.frontUserId,
                          class: "form-control is-required",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedRole) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: role.key,
                              key: role.key
                            }, _toDisplayString(role.value), 9, _hoisted_48))
                          }), 128))
                        ], 8, _hoisted_47), [
                          [_vModelSelect, _ctx.selectedRole]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.motto.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('EstateAgentEdit.motto')) + ":", 1),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.form.motto.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentProfileForm_motto",
                        name: "motto",
                        class: "form-control",
                        rows: "3"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.motto.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.motto.$dirty && _ctx.v$.form.motto.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.motto.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.description.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('EstateAgentEdit.description')) + ":", 1),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.form.description.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentProfileForm_description",
                        name: "description",
                        class: "form-control",
                        rows: "5"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.description.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.description.$dirty && _ctx.v$.form.description.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.description.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('EstateAgentEdit.languages')) + ":", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formModel.languages, (language) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: language.key
                        }, [
                          _createElementVNode("label", _hoisted_55, [
                            _createElementVNode("span", {
                              class: _normalizeClass('flag-lang-' + language.key)
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(language.value) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.languages) = $event)),
                              value: language.key
                            }, null, 8, _hoisted_56), [
                              [_vModelCheckbox, _ctx.form.languages]
                            ]),
                            _hoisted_57
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.estateAgentImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgentImage.isError }])
                        }, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              (_ctx.estateAgentImage.isSuccess)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    (_ctx.estateAgentImage.isSuccess)
                                      ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                          key: 0,
                                          url: _ctx.estateAgentImage.url,
                                          width: 220,
                                          height: 220,
                                          hrmode: "max",
                                          alt: _ctx.estateAgentImage.file,
                                          draggable: false
                                        }, null, 8, ["url", "alt"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteEstateAgentFile())),
                                      class: "delete-photo"
                                    }),
                                    _createElementVNode("span", {
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editEstateAgentFile())),
                                      class: "edit-photo"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("label", _hoisted_62, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/jpeg",
                                      ref: "estateAgentImage",
                                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleEstateAgentImageUpload()))
                                    }, null, 544),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('EstateAgentEdit.photo-button')), 1),
                                    _createElementVNode("i", {
                                      innerHTML: _ctx.$t('EstateAgentEdit.photo-button-info')
                                    }, null, 8, _hoisted_63)
                                  ])),
                              (_ctx.estateAgentImage.isUploading)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "progress-bar",
                                    style: _normalizeStyle({ width: _ctx.estateAgentImage.uploadPercentage + '%' })
                                  }, null, 4))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.estateAgentImage.isError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.estateAgentImage.text), 1))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("button", _hoisted_67, _toDisplayString(_ctx.$t('EstateAgentEdit.button-save')), 1),
                    (_ctx.model.canDelete)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          disabled: _ctx.model.isOwner,
                          class: "button button--danger",
                          type: "button",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showConfirmDelete = true))
                        }, _toDisplayString(_ctx.$t('EstateAgentEdit.button-delete')), 9, _hoisted_68))
                      : _createCommentVNode("", true),
                    (!_ctx.model.canDelete)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          disabled: _ctx.model.isOwner,
                          class: "button button--danger",
                          type: "button",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showConfirmArchive = true))
                        }, _toDisplayString(_ctx.$t('EstateAgentEdit.button-archive')), 9, _hoisted_69))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 32)
            ])
          ])
        ]),
        (_ctx.showEstateAgentImageModal)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: "#container"
            }, [
              _createVNode(_component_Cropper, {
                img: _ctx.estateAgentImage.url,
                fileName: _ctx.estateAgentImage.file,
                aspectRatio: 1 / 1,
                accept: "image/jpeg",
                onUpload: _ctx.uploadEstateAgentImage,
                onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showEstateAgentImageModal = false))
              }, null, 8, ["img", "fileName", "onUpload"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}